'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustMetric {
  id: string;
  icon: string;
  value: string;
  label: string;
}

const TrustSignalBar = () => {
  const [currentMetricIndex, setCurrentMetricIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const trustMetrics: TrustMetric[] = [
    {
      id: 'experience',
      icon: 'CalendarIcon',
      value: '15+',
      label: 'lat doświadczenia',
    },
    {
      id: 'clients',
      icon: 'UsersIcon',
      value: '5000+',
      label: 'zadowolonych klientów',
    },
    {
      id: 'partners',
      icon: 'BuildingLibraryIcon',
      value: '20+',
      label: 'partnerów bankowych',
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMetricIndex((prev) => (prev + 1) % trustMetrics.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [trustMetrics.length]);

  return (
    <>
      <div className="hidden md:flex items-center gap-8 px-6 py-3 bg-muted/50 rounded-lg">
        {trustMetrics.map((metric) => (
          <div key={metric.id} className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
              <Icon name={metric.icon as any} size={20} variant="outline" className="text-primary" />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-headline font-bold text-primary leading-tight">
                {metric.value}
              </span>
              <span className="text-xs text-muted-foreground leading-tight">
                {metric.label}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div
        className={`md:hidden fixed top-[60px] left-0 right-0 z-40 bg-card border-b border-border transition-all duration-250 ${
          isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
        }`}
      >
        <div className="flex items-center justify-center gap-3 px-6 py-3">
          <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg">
            <Icon
              name={trustMetrics[currentMetricIndex].icon as any}
              size={16}
              variant="outline"
              className="text-primary"
            />
          </div>
          <div className="flex items-center gap-2">
            <span className="text-base font-headline font-bold text-primary">
              {trustMetrics[currentMetricIndex].value}
            </span>
            <span className="text-sm text-muted-foreground">
              {trustMetrics[currentMetricIndex].label}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrustSignalBar;